import { render, staticRenderFns } from "./newsDialog.vue?vue&type=template&id=7f5c8fd4"
import script from "./newsDialog.vue?vue&type=script&lang=js"
export * from "./newsDialog.vue?vue&type=script&lang=js"
import style0 from "./newsDialog.vue?vue&type=style&index=0&id=7f5c8fd4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports